import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {SignupForm} from './Form';
import {SignupSuccess} from './Success';
import {Confirmation} from './Confirmation';

const Signup = () => (
  <>
    <Switch>
      <Route path="/signup/confirmation/:token" component={Confirmation} />
      <Route path="/signup/success" component={SignupSuccess} />
      <Route path="/signup" component={SignupForm} />
    </Switch>
  </>
);

export {Signup};
